import React from "react";
import withReducer from "../../../components/shared/with-reducer";
import injectableReducers from "./injectable";
import Appointment from "./component";
import { bindActionCreators } from "redux";
import { setPageLoading } from "../../../components/shared/car-animation-loader/actions";
import withLayout from "../../../components/desktop/layout/component";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setPageLoadingConnect: setPageLoading
}, dispatch);

export default withReducer(injectableReducers)(mapStateToProps, mapDispatchToProps)(withLayout(Appointment, true, false, false));
